import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {DashboardComponent} from './dashboard.component';
import {PermissionsGuard} from '../permissions.guard';
import {Permission} from '../shared/utils/permission.enum';
import {RoutingMenuItemModel} from '../shared/utils/routing-menu-item.model';


const routes: Routes = [
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [PermissionsGuard],
    canActivateChild: [PermissionsGuard],
    data: {
      hasSideBarMenu: true,
      breadcrumb: 'DASHBOARD',
      permissions: [
        Permission.ADMIN_SPO_VIEW,
        Permission.PARTNER_SPO_VIEW,
        Permission.ADMIN_CLAIM_VIEW,
        Permission.PARTNER_CLAIM_VIEW,
        Permission.ADMIN_PNC_VIEW,
        Permission.PARTNER_PNC_VIEW,
        Permission.PLANNER_PNC_VIEW,
        Permission.PRICE_PLANNER_PNC_VIEW,
        Permission.TECHNICIAN_PNC_VIEW,
        Permission.EE_SPECIALIST_PNC_VIEW,
        Permission.ADMIN_ROLE_VIEW,
        Permission.PARTNER_ROLE_VIEW
      ],
      menuItem: {
        label: 'Dashboard',
        icon: 'iwp-icon-iwp_dashboard',
        index: 0
      } as RoutingMenuItemModel
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardRoutingModule { }
